import HttpServices from './index';

class ReportAbuseServices extends HttpServices {
  createReportAbuse = (data, path) =>  this.http.post('/suggestions/objections', data, this._setHeaderBoardsPath(path));
}
export default new ReportAbuseServices();
